import { Component, OnInit, Input, Inject } from '@angular/core';
import { BlahService } from '@headpower/blah-ng';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'hpo-delete-confirmation-dialog',
    templateUrl: './delete-confirmation-dialog.component.html',
    styleUrls: ['./delete-confirmation-dialog.component.scss']
})
export class DeleteConfirmationDialogComponent implements OnInit {

    public title: string;
    public description: string;
    public hint: string;
    public translate: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private blahService: BlahService,
        public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>) { }

    public ngOnInit(): void {
        // Hardcode width to keep confirmation dialogs tidy and consistent
        this.dialogRef.updateSize('480px');

        this.translate = this.data.translate ? true : false;
        this.title = this.translate ? this.blahService.blah(this.data.title, this.blahService.currentLocale) : this.data.title;
        this.description =
            this.translate ? this.blahService.blah(this.data.description, this.blahService.currentLocale) : this.data.description;
        if (this.data.hint) {
            this.hint = this.translate ? this.blahService.blah(this.data.hint, this.blahService.currentLocale) : this.data.hint;
        }
    }

    /**
     * Return true
     */
    public delete(): void {
        this.dialogRef.close(true);
    }

    /**
     * Return false
     */
    public cancel(): void {
        this.dialogRef.close(undefined);
    }

}
